import InteractiveContext from "context/InteractiveContext";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import "../assets/scss/Views/welcome.scss";
import PrimaryButton from "../Components/PrimaryButton";
import VideoJS from "../Components/VideoPlayer/VideoJS";
const Start = () => {
  const { isMuted, toggleMuted } = useContext(InteractiveContext);
  const playerRef = useRef(null);
  const onPlayerReadyHandler = (player) => {
    playerRef.current = player;
    playerRef.current.play();
  };
  const [videoJsOptions] = useState({
    controls: false,
    autoplay: true,
    loop: true,
    sources: "/videos/ekran-poczatkowy.mp4",
  });

  const [isEnabledSound, setIsEnabledSound] = useState(false);
  const { t } = useTranslation();
  useEffect(() => {
    setIsEnabledSound(!isMuted);
  }, [isMuted, setIsEnabledSound]);

  const enableSounds = () => {
    toggleMuted(false);
  };

  return (
    <div onClick={enableSounds}>
      {!(typeof navigator !== "undefined" && isMobile()) && !isEnabledSound && (
        <Cursor />
      )}
      <div className="position-absolute bottom-0 w-100 d-flex justify-content-center pb-5 mb-2">
        <Link className="nav-link" to="/intro">
          <PrimaryButton
            className="primary"
            text={t("Enter the Project")}
            hoveredText={t("Enter the Project")}
            onClick={enableSounds}
          />
        </Link>
      </div>
      <VideoJS options={videoJsOptions} onPlayerReady={onPlayerReadyHandler} />
    </div>
  );
};

const isMobile = () => {
  const ua = navigator.userAgent;
  return /Android|Mobi/i.test(ua);
};

const Cursor = () => {
  const { t } = useTranslation();
  const [position, setPosition] = useState({ x: 0, y: 0 });
  useEffect(() => {
    addEventListeners();
    return () => removeEventListeners();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addEventListeners = () => {
    document.addEventListener("mousemove", onMouseMove);
  };

  const removeEventListeners = () => {
    document.removeEventListener("mousemove", onMouseMove);
  };

  const onMouseMove = (e) => {
    setPosition({ x: e.clientX, y: e.clientY });
  };

  return (
    <div
      className="cursor"
      style={{ left: `${position.x}px`, top: `${position.y}px` }}
    >
      {t("Click anywhere to activate sound")}
    </div>
  );
};

export default Start;
